import Bugsnag from './Bugsnag';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);
